export const apiList = {
  postBIURL: `/bi`,
  getBIURL: `/bi/`, // oacl
  getCHATRECORDSURL: `/bi/`, // oacl/chatRecords
  putContractStatusURL: `/bi/`,  // oacl/contractStatus

  postChangeBillDateURL: `/bi/amendment/changeBillDate`,
  postWaiverURL: `/bi/amendment/waiver`,
  postTerminationURL: `/bi/amendment/termination`,
  getAmendmentsURL: `/bi/amendment/`, // oacl

  getWorklistURL: `/worklist`,
  getWorklistByIDURL: `/worklist/`, // oacl
  putWorklistStatusURL: `/worklist/`,  // oacl/status
  putWorklistRemarkURL: `/worklist/`,  // oacl/remark
  putWorklistBatchStatusURL: `/worklist/batchStatus`,

  getQuoteURL: `/file/`, // file/oacl/quote
  postAttachmentURL: `/file/`, // file/oacl/attachment/fileName
  getAttachmentURL: `/file/`, // file/oacl/attachment/fileName
  getHistoryURL: `/history/`, // oacl

  geteBillUserProfile: '/ebill/api/access-control',
  geteBillInvoiceList: '/ebill/api/invoices?',
  geteBillWebBIUserList: '/ebill/api/user/application/8',

  getReportURL: `/report/oaclInvoiceReport`, // oaclInvoiceReport
};
